import type { SidebarItem } from '@shared/design-system';
import { ROUTE_VIEW_PERMISSION } from '../../lib/permissions';

/**
 * Filters nav items by permission, then drops section headers that have no
 * following non-section item (avoids orphan headers).
 */
export function filterNavItems(
  items: SidebarItem[],
  hasPermission: (code: string) => boolean,
): SidebarItem[] {
  // 1. Drop gated items the user cannot view.
  const visible = items.filter((it) => {
    if (!('id' in it) || !it.id) return true; // section header — handled in pass 2
    const code = ROUTE_VIEW_PERMISSION[it.id];
    return code ? hasPermission(code) : true; // ungated route
  });

  // 2. Drop section headers with no following item before the next header/end.
  return visible.filter((it, idx) => {
    if ('id' in it && it.id) return true;
    const next = visible[idx + 1];
    return next !== undefined && 'id' in next && Boolean(next.id);
  });
}
